module.exports = __webpack_public_path__ + "static/grandmaster-flowers-poster-1a9338a8124deba7a2f3a992970b80d2.jpg";